export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (badges, content, currentSection, functionLinks, hashUrl, user) {
      pug_html = pug_html + "\u003Cdiv class=\"app\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ca class=\"hamburger app-sidebar__toggle\" href=\"#\"\u003E\u003C\u002Fa\u003E\u003Cdiv class=\"scan padded\"\u003E";
if (user && user.role != "Casual Delivery") {
pug_html = pug_html + "\u003Ca href=\"#\u002Fscan\"\u003E\u003Ci class=\"fa-solid fa-camera\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"update-avail\"\u003Eupdate app\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sidebar\"\u003E\u003Cimg src=\"images\u002Ficon.png\"\u003E\u003Cdiv class=\"update-avail clickable\"\u003Eupdate app\u003C\u002Fdiv\u003E";
if (functionLinks) {
pug_html = pug_html + "\u003Col class=\"function-links\"\u003E";
var currentSection = undefined
// iterate functionLinks
;(function(){
  var $$obj = functionLinks;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var link = $$obj[pug_index0];
if (! link.roles || (user && link.roles.indexOf(user.role) >= 0)) {
if (currentSection && link.section && currentSection != link.section) {
pug_html = pug_html + "\u003Cli\u003E\u003Chr\u003E\u003C\u002Fli\u003E";
}
currentSection = link.section
pug_html = pug_html + ("\u003Cli\u003E\u003Ca" + (pug_attr("class", pug_classes(["function-link",{"active-function": link.url == hashUrl}], [false,true]), false, true)+pug_attr("href", (link.fullurl || `#${link.url}`), true, true)+pug_attr("target", link.target, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = link.name) ? "" : pug_interp)));
var badge = badges[link.url];
if (badge && link.url != hashUrl && (badge.red || badge.orange || badge.green)) {
pug_html = pug_html + "\u003Cdiv class=\"badges\"\u003E";
if (badge.red) {
pug_html = pug_html + "\u003Cdiv class=\"badge red\"\u003E" + (pug_escape(null == (pug_interp = badge.red) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (badge.orange) {
pug_html = pug_html + "\u003Cdiv class=\"badge orange\"\u003E" + (pug_escape(null == (pug_interp = badge.orange) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (badge.green) {
pug_html = pug_html + "\u003Cdiv class=\"badge green\"\u003E" + (pug_escape(null == (pug_interp = badge.green) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var link = $$obj[pug_index0];
if (! link.roles || (user && link.roles.indexOf(user.role) >= 0)) {
if (currentSection && link.section && currentSection != link.section) {
pug_html = pug_html + "\u003Cli\u003E\u003Chr\u003E\u003C\u002Fli\u003E";
}
currentSection = link.section
pug_html = pug_html + ("\u003Cli\u003E\u003Ca" + (pug_attr("class", pug_classes(["function-link",{"active-function": link.url == hashUrl}], [false,true]), false, true)+pug_attr("href", (link.fullurl || `#${link.url}`), true, true)+pug_attr("target", link.target, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = link.name) ? "" : pug_interp)));
var badge = badges[link.url];
if (badge && link.url != hashUrl && (badge.red || badge.orange || badge.green)) {
pug_html = pug_html + "\u003Cdiv class=\"badges\"\u003E";
if (badge.red) {
pug_html = pug_html + "\u003Cdiv class=\"badge red\"\u003E" + (pug_escape(null == (pug_interp = badge.red) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (badge.orange) {
pug_html = pug_html + "\u003Cdiv class=\"badge orange\"\u003E" + (pug_escape(null == (pug_interp = badge.orange) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (badge.green) {
pug_html = pug_html + "\u003Cdiv class=\"badge green\"\u003E" + (pug_escape(null == (pug_interp = badge.green) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fol\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cmain class=\"app-content\"\u003E\u003Cdiv\u003E" + (null == (pug_interp = content) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fmain\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "badges" in locals_for_with ?
        locals_for_with.badges :
        typeof badges !== 'undefined' ? badges : undefined, "content" in locals_for_with ?
        locals_for_with.content :
        typeof content !== 'undefined' ? content : undefined, "currentSection" in locals_for_with ?
        locals_for_with.currentSection :
        typeof currentSection !== 'undefined' ? currentSection : undefined, "functionLinks" in locals_for_with ?
        locals_for_with.functionLinks :
        typeof functionLinks !== 'undefined' ? functionLinks : undefined, "hashUrl" in locals_for_with ?
        locals_for_with.hashUrl :
        typeof hashUrl !== 'undefined' ? hashUrl : undefined, "user" in locals_for_with ?
        locals_for_with.user :
        typeof user !== 'undefined' ? user : undefined));
    ;;return pug_html;}